import { API_BASE_URL_ACCOUNT } from '@/common/constant'
import {
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
  HTTP_METHOD_GET,
} from '@/common/api/api.service'
import { normalizeConnections } from '../../normalize/normalize-connections'

/**
 * SNS 계정 연결 정보 호출
 * - api명세서: https://contentwavve.atlassian.net/wiki/spaces/PDD/pages/1604882048/account-gate+GET+v1+connections+-+SNS
 * @param {object} { token: string } credential
 * @returns {Promise<{data: {wavveId: string, snsList: any[]}} | undefined>}
 */
export const getConnections = async ({ token }) => {
  if (!token) {
    return
  }
  const url = `${API_BASE_URL_ACCOUNT}/v1/connections`
  const response = await apiRequest(
    commonRequestInstanceToAxiosRequestInfo({
      url,
      method: HTTP_METHOD_GET,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`,
      },
    }),
    (error) => {
      return { error: error.response }
    },
  )
  if (!response || response?.error) {
    return response
  }

  return normalizeConnections(response)
}
